import { useTranslation } from 'react-i18next';
import { MaterialSymbol, TextField, withStyles } from 'vopay';
import { usePermissionsContext } from './PermissionsContext';
import styles from './PermissionsSearch.module.scss';

const cn = withStyles(styles);

/** `Permissions.Search`: filters the sections by permission or section label. */
export default function PermissionsSearch() {
  const { editor } = usePermissionsContext();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Permissions' });

  return (
    <TextField
      name="permissionSearch"
      placeholder={t('searchPlaceholder', { defaultValue: 'Search Permissions' })}
      value={editor.searchTerm}
      onChange={(e) => editor.setSearchTerm(e.target.value)}
      variant="outlineShadow"
      elementLeft={
        <div className={cn('searchIconWrapper')}>
          <MaterialSymbol icon="search" size="24px" />
        </div>
      }
    />
  );
}
